import React from "react";
import { HEIGHT, OVERLAY_WIDTH } from "../store/DEFAULT";

function Overlay(props) {
  const overlayStyle = {
    position: "absolute",
    top: "0",
    left: "200px",
    width: OVERLAY_WIDTH,
    height: HEIGHT,
    background: "rgba(0, 0, 0, 0.3)", // Adjust the alpha value for the desired transparency
  };
  return <div style={overlayStyle}></div>;
}
export default Overlay;
